import { useMemo } from "react";
import useLocale from "providers/LocaleProvider/useLocale";

interface UseNumberFormatterProps {}

function useNumberFormatter(props?: UseNumberFormatterProps) {
  const { locale } = useLocale();
  return useMemo(() => Intl.NumberFormat(locale), [locale]);
}

export default useNumberFormatter;
